<div
  data-qa="ai-button"
  class="ai-gen-button {{fontClass}} {{disabled ? 'cursor-not-allowed opacity-40' : 'cursor-pointer'}}"
  (click)="buttonClickEmitter()">
  <div class="ai-icon-container">
    <svg class="star-1">
      <use
        [attr.xlink:href]="iconPath + '#img'"
        [attr.href]="iconPath + '#img'">
      </use>
    </svg>
    <svg class="star-2">
      <use
        [attr.xlink:href]="iconPath + '#img'"
        [attr.href]="iconPath + '#img'">
      </use>
    </svg>
    <svg class="star-3">
      <use
        [attr.xlink:href]="iconPath + '#img'"
        [attr.href]="iconPath + '#img'">
      </use>
    </svg>
  </div>
  <div class="span">
    <ng-content></ng-content>
  </div>
</div>
